import { Tier } from '../types';

export const TIER_LABELS: Record<Tier, string> = {
  free: 'Free',
  assessment: 'Assessment Kit',
  conversion: 'Conversion Kit',
  full: 'Full Kit',
};

export const TIERS = Object.keys(TIER_LABELS) as Tier[];
